import useInitBroadcast from 'modules/overlay-v2/ui/hooks/initializers/use-init-broadcast';
import useInitDataOverlayV2 from 'modules/overlay-v2/ui/hooks/initializers/use-init-data-overlay-v2';
import useInitSubscribeOverlayV2 from 'modules/overlay-v2/ui/hooks/initializers/use-init-subscribe-overlay-v2';
import { useParsePopupMessage } from 'modules/overlay-v2/ui/hooks/use-parse-popup-message';

/**
 * Запуск панели управления. Набор тот же, что у оверлея; `useParsePopupMessage` здесь нужен
 * ради обратного сообщения `popupLoaded` — по нему панель понимает, что открытое окно
 * загрузилось, и включает кнопку «Синхронизировать окна».
 */
function useInitControlPanelV2() {
  useInitBroadcast();
  useInitDataOverlayV2();
  useInitSubscribeOverlayV2();
  useParsePopupMessage();
}

export default useInitControlPanelV2;
